import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import { stringScheme } from 'src/utils/validation-schemes';
import { useEditKnowledgeBaseNameMutation } from 'src/services';
import Input from 'src/components/Input/Input';
import React, { useEffect } from 'react';
import { clsx } from 'clsx';
import { CheckIcon } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/CheckIcon/CheckIcon';
import { AddItemIconDisabled } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/AddItemIcon/AddItemIconDisabled';
import { useNotification } from 'src/hooks/useNotification';

export const CreateNewKBInput = ({ item }) => {
  const notification = useNotification();
  const [
    editKnowledgeBase,
    { isLoading: editKnowledgeBaseIsLoading, isSuccess: isSuccessEditKnowledgeBase },
  ] = useEditKnowledgeBaseNameMutation();

  useEffect(() => {
    if (item) {
      setValue('name', item.name);
    }
  }, [item]);

  useEffect(() => {
    if (isSuccessEditKnowledgeBase) {
      notification.success('Knowledge Base was successfully updated!');
    }
  }, [isSuccessEditKnowledgeBase]);

  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      name: item ? item.name : '',
    },
    resolver: yupResolver(
      object({
        name: stringScheme({ required: true }).label('DataBase Name'),
      }),
    ),
  });

  const submit = ({ name }) => {
    if (name && item?.id && name !== item.name) {
      editKnowledgeBase({
        name: name,
        knowledge_base_id: item?.id,
      });
    }
  };

  const onBlur = () => {
    handleSubmit(submit)();
  };

  return (
    <form onSubmit={handleSubmit(submit)} className={'w-full flex flex-row items-start gap-5'}>
      <div className={'pt-5'}>
        <CheckIcon className={'invisible'} />
      </div>
      <div className={'w-full flex flex-col gap-1.5'}>
        <Controller
          control={control}
          name="name"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Knowledge base name:'}
              placeholder={'AI Knowledge Base'}
              className={clsx(
                'border border-[#B8C1C633]',
                editKnowledgeBaseIsLoading && 'blur-sm animate-pulse pointer-events-none',
              )}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
              onBlur={onBlur}
              readonly={editKnowledgeBaseIsLoading}
            />
          )}
        />
      </div>
      <div className={clsx('invisible')}>
        <AddItemIconDisabled />
      </div>
    </form>
  );
};
